import { ref } from "vue";

const isLocked = ref<boolean>(localStorage.getItem("gymya_locked") === "1");
const inactivityLimit = 8 * 60 * 1000; // 8 min

const lastActivity = ref<number>(Date.now());

let checker: any = null;

export function useAppLock() {
  const setPin = (pin: string) => {
    localStorage.setItem("gymya_pin", pin);
  };

  const checkPin = (pin: string) => {
    return localStorage.getItem("gymya_pin") === pin;
  };

  const lockApp = () => {
    isLocked.value = true;
    localStorage.setItem("gymya_locked", "1");
  };

  const unlockApp = () => {
    isLocked.value = false;
    localStorage.setItem("gymya_locked", "0");

    updateActivity();
  };

  const updateActivity = () => {
    lastActivity.value = Date.now();
  };

  const startInactivityChecker = () => {
    // ✅ restore lock state on app start
    const saved = localStorage.getItem("gymya_locked");

    if (saved === "1") {
      isLocked.value = true;
    }

    if (checker) return;

    const events = ["mousemove", "click", "keydown", "scroll", "touchstart"];

    events.forEach((event) => {
      window.addEventListener(event, () => {
        if (!isLocked.value) {
          updateActivity();
        }
      });
    });

    checker = setInterval(() => {
      if (isLocked.value) return;

      const now = Date.now();
      const diff = now - lastActivity.value;

      if (diff >= inactivityLimit) {
        lockApp();
      }
    }, 1000);
  };

  return {
    isLocked,
    setPin,
    checkPin,
    lockApp,
    unlockApp,
    startInactivityChecker,
  };
}
